import { AuthService } from './auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Sparrow (PDF y envío de correo) no consume el JWT de la app: su
 * SeguridadMiddleware lo reenvía a un servicio de seguridad externo que hoy está
 * inalcanzable, y descarta el resultado. Mandarle el header sólo conseguía que
 * cada PDF tardara ~135 s esperando ese timeout, además de exponer el token del
 * usuario a un tercero. Por eso se excluye del interceptor.
 */
const esPeticionASparrow = (url: string): boolean =>
{
    const base = (environment.sparrowreport || '').replace(/\/+$/, '');
    return base.length > 0 && url.startsWith(base);
};

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const tokenInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);
    let newReq = req.clone();

    if ( authService.accessToken && !req.url.includes('auth/local') && !esPeticionASparrow(req.url) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer '+ authService.accessToken),
        });
    } 

    return next(newReq).pipe(
        catchError((error) =>
        {
            return throwError(error);
        }),
    );
};
